'use es6';

export const GOOGLE_FREE = 'GOOGLE_FREE';
export const GOOGLE_APPS = 'GOOGLE_APPS';
export const OUTLOOK365 = 'OUTLOOK365';
export const UNKNOWN = 'UNKNOWN';

/* eslint-env commonjs */
// This temporary hack ensures module system compatibility.
// Read more at go/treeshaking
if (!!module && !!module.exports) {
  module.exports.default = Object.assign({}, module.exports);
}